import { ErrorWarningTypes } from '../enums/error-warning-types.enum';

export class ErrorData {
  constructor(public title: string, public message: string, public icon: ErrorWarningTypes = ErrorWarningTypes.Error) {}
}
